// extracted by mini-css-extract-plugin
export var dummy = "lcLayout-module--dummy--ea4af";
export var layoutWrapper = "lcLayout-module--layoutWrapper--62cdf";
export var main = "lcLayout-module--main--27ee1";
export var noScroll = "lcLayout-module--no-scroll--6ce5b";
export var sidebar = "lcLayout-module--sidebar--0566d";